import { CustomElement } from '@aurelia/runtime-html';
export const name = "create-section";
export const template = "﻿<template>\n  <au-viewport></au-viewport>\n</template>\n";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
